import { ServiceType } from "@bufbuild/protobuf";

import { SupportService } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_connect";

/**
 * Service definitions for dev-tools
 *
 * This file defines all available services for the dev-tools interface.
 * Each service includes protobuf service definition, API client mapping,
 * and availability flags to control which services are shown to users.
 *
 * To add a new service:
 * 1. Import the service definition from @safetyculture/s12-apis-connect-web
 * 2. Add the service to ALL_SERVICES array with proper configuration
 * 3. Ensure the API client is available in src/api/index.ts
 * 4. Set clientAvailable: true when the client is ready
 */
export interface ServiceDefinition {
  id: string;
  name: string;
  description: string;
  service: ServiceType;
  apiClient?: string;
  available: boolean;
  clientAvailable: boolean;
}

export const ALL_SERVICES: ServiceDefinition[] = [
  {
    id: "support",
    name: "Support Service",
    description: "Tools and support functionality",
    service: SupportService,
    apiClient: "supportServiceConnectClient",
    available: true,
    clientAvailable: true,
  },
  // Additional services can be added here when their API clients are configured
  // Follow the pattern above and ensure clientAvailable is set to true
];

// Only export services that have both the service definition AND working API clients
export const AVAILABLE_SERVICES: ServiceDefinition[] = ALL_SERVICES.filter(
  (service) => service.available && service.clientAvailable
);

/**
 * Type definition for all available Support Service method names
 */
export type MethodNames = keyof typeof SupportService.methods;
